//this will be a singleton that keeps a reference to the store
var store;

export function setStore(st) {
    store = st;
}

export function dispatchPopupMessage(action) {
    store.dispatch(action)
}